export class WalletDeleteDto {
	deletedInInsuranceAt: string;
	walletId: string;

	constructor({ deletedInInsuranceAt, walletId }: WalletDeleteDto) {
		this.deletedInInsuranceAt = deletedInInsuranceAt;
		this.walletId = walletId;
	}
}
